module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-5",
      "lang": "en-GB"
    }
  }, [_vm._v("R"), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("espectively Ours")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("We sing, we dance, we play")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("But how long until we have to weigh")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Our talents. And wonder how far they will get us.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("In a world of competition")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("We are left only to petition")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("For our futures, painted in the silver lines of fate.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("But wait.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("They have left us a world broken,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("With a thousand words unspoken.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Stuck with our ever expanding ambition")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("We are left wishing")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("For a version of our future,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Where we are not left to pick up")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("The pieces left by the world’s past abuser.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Where stress and sea levels are rising.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("But the polar ice caps are melting.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("And we are left waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("So the future stays vacant.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("But how long until our chances run out?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Until we break this long lasting cycle")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("And nurse the world back into survival")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c560d600","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035801855_EPUB-9.vue
// module id = 84
// module chunks = 0